<template>
  <div></div>
</template>

<script>
import { store } from "@/store/survey"
import surveyMixin from '../mixins/surveyMixin';

export default {
  mixins: [surveyMixin],
  data() {
    return {
      survey: {}
    }
  },
  methods: {
    getFirstItemId(targetArray) {
      return targetArray.find(x => x.orderNum === 101)
    }
    // goToNextPage (in surveyMixin)
  },
  async created() {
    if(Object.keys(store.state.survey).length === 0){ // if the stored survey object is empty...
      console.log(`Store empty, getting ${this.$route.params.surveyId} survey in language - ${this.$route.params.lang}`)
      this.survey = await store.getSurveyAction(this.$route.params.surveyId, this.$route.params.lang, this.$route.query)
      
    }
    // get the first survey item and navigate to the relevant view
    console.log(store.survey);
    this.goToNextPage(100)
  }
}
</script>